export default __webpack_public_path__ + "static/11-957c317ab979c18a9fd601ece38eb90e.jpg";